import { Component } from '@angular/core';
import { SiteVisitPdfJobService } from '../services/site-visit-pdf/site-visit-pdf-job.service';

@Component({
  selector: 'app-site-visit-pdf-job-toast',
  templateUrl: './site-visit-pdf-job-toast.component.html',
  styleUrl: './site-visit-pdf-job-toast.component.scss',
  standalone: false,
})
export class SiteVisitPdfJobToastComponent {
  constructor(public pdfJob: SiteVisitPdfJobService) {}
}
